'use client'

export async function lastNedFil(endepunkt: string, parametre: Record<string, string>, filnavn: string) {
    const respons = await fetch(`${endepunkt}?${new URLSearchParams(parametre)}`)
    if (!respons.ok) {
        throw new Error(`Utskriftsendepunktet svarte ${respons.status}`)
    }

    const url = URL.createObjectURL(await respons.blob())
    const lenke = document.createElement('a')
    lenke.href = url
    lenke.download = respons.headers.get('Content-Disposition')?.match(/filename="([^"]+)"/)?.[1] ?? filnavn
    document.body.appendChild(lenke)
    lenke.click()
    lenke.remove()
    setTimeout(() => URL.revokeObjectURL(url), 0)
}
